<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="dm05">
<div class="chapterHead">
<h2 class="chapterTitle" style="text-indent: 0%;"> </h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 0%;"><em class="italic">The eyes relay what we desire; in our hearts love lies buried.</em></p>
<p class="extractSource" style="margin-left: 0%;">—<span class="smallCaps">LAYLA BINT SA</span><span class="smallCaps"><img alt="image" class="epubimage" src="Images/c.jpg"/>D IBN MAHDI OF THE BANU</span> <span class="smallCaps"> <img alt="image" class="epubimage" src="Images/c.jpg"/>AMIR<br/></span> (the beloved of Qays ibn al-Mulawwah, the Madman of Layla, or <em class="italic">Majnun Layla</em>) c. eighth century <span class="smallCaps">C.E</span>. (from <em class="italic">The Book of Songs,</em> volume II, Abu al-Faraj al-Isfahani, d. 967 <span class="smallCaps">C.E</span>.)</p>
</div>
<p class="centerImage"><img alt="image" src="Images/t.jpg" style="height:100%;"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765316578_dm05.vue?ad792378